<template>

    <div class="container mb-3">
        <div class="row">
            <div class="row">
                <div class="col-md-6">
                    <h3>State Master</h3>
                </div>
                <div class="col-md-6">
                    <!-- <pre>{{ form }} {{ query }}</pre> -->
                    <button class="btn btn-primary " v-if="!seen" @click="seen = !seen" style="float: right;"
                        id="btnAdd">
                        <i class="fa fa-plus-circle" aria-hidden="true"></i> Add State</button>
                    <button class="btn btn-primary" v-if="seen" @click="seen = !seen" style="float: right;"
                        id="btnHide">
                        <i class="fa fa-minus-circle" aria-hidden="true"></i>
                        Hide</button>
                </div>
            </div>

        </div>

        <div class="row" id="mainform" v-if="seen">
            <div class="col">

                <form @submit="onSubmit" class="needs-validation state-mas">
                    <div class="row">
                        <div class="col-md-4 mb-3">
                            <label for="countryId" class="form-label">Countery * </label>
                            <select v-model="form.countryId" id="countryId" class="form-select" aria-label="Default select example">
                                <option selected Disabled>Select Country</option>
                                <option v-for="country in countries" :key="country.id" :value="country.id">{{
                                    country.countryName
                                }}</option>
                            </select>   
                        </div>
                        <div class="col-md-6 mb-3">
                            <label for="stateName" class="form-label">state Name </label>
                            <input type="text" v-model="form.stateName" class="form-control has-validation"
                                id="stateName" placeholder="Company Name" max="100" maxlength="100" required
                                autocomplete="off">
                            <div v-if="errors.stateName" class="invalid-feedback">{{ errors.stateName }}</div>
                        </div>
                        
                        <div class="btn-bottom">
                            <input type="submit" :value="btnText" class="btn  btn-primary" />
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <div class="container">
        <hr />
        <div class="table-responsive">
            <table class="table" ref="stateTable">
                <thead>
                    <tr>
                        <th>#ID</th>
                        <th>State Name</th>                        
                        <th>Country Name</th>                        
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="state in states" :key="state.id">
                        <td>{{ state.id }}</td>
                        <td>{{ state.stateName }}</td>
                        <td>{{ state.countryName }}</td>

                        
                        <td> 
                            <button class="btn btn-success btn-sm" @click="editdata(state.id)"><i
                                    class="fa fa-pencil" aria-hidden="true"></i>
                                Edit</button> <button class="btn btn-danger btn-sm"
                                @click="deletedata(state.id)"><i class="fa fa-trash" aria-hidden="true"></i>
                                Delete</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="container" v-if="loading">
        <div class="row">
            <div class="col">
                <Spinner />
            </div>
        </div>
    </div>
   
</template>

<script>

import { Country } from '../services/Country';
import { State } from '../services/State';
import Spinner from '../components/Spinner.vue';
import $ from "jquery";
import dt from "datatables.net";


$(function () {
    //  alert('ok');
    // this.dt = $('#cityTable').DataTable();
});
export default {
    name: 'State',
    components: {        
        Spinner

    },
    data() {
        return {
            form: {
                id: '',
                stateName: '',
                countryId : '',

            },
            states: [],
            countries: [],            
            seen: false, 
            loading : false,           
            dt: dt,            
            btnText: 'Save',            
            errors: [],
            
        }
    },
    async created() {    
        try {
            this.loading = true;
            let response = await Country.getCountries();
            // console.log(response.data);
            this.countries = response.data;
            this.loading = false
        }
        catch (error) {
            this.errors = error;
            this.loading = false;
        }    
        try {
            this.loading = true;
            let response = await State.getStates();
            // console.log(response.data);
            this.states = response.data;
            this.loading = false
        }
        catch (error) {
            this.errors = error;
            this.loading = false;
        }

    },
    updated() {

    },
    mounted() {
        this.dt = $(this.$refs.stateTable).DataTable();
        
    },
    watch: {
        states() {
            this.dt.destroy();
            this.$nextTick(() => {
                this.dt = $(this.$refs.stateTable).DataTable()
            })
        }

    }, methods: {
        checkValidations() {
            var stateName = document.getElementById("stateName");
            

            if (this.errors.stateName) stateName.classList.add("is-invalid"); else stateName.classList.add("is-valid");
            
        },
        removeValidations() {
            var stateName = document.getElementById("stateName");
            
            stateName.classList.remove("is-invalid");
            stateName.classList.remove("is-valid");
            
        },
        async onSubmit(e) {
            e.preventDefault()
            if (!this.form.stateName) {
                alert('Please Enter state name')
                return
            }



            // const response = await state.createstate(form);
            if (this.btnText === 'Save') {
                try {
                    this.loading = true;
                    const response = await State.createState(this.form);
                    // console.log(response);
                    if (response.data.status == 'success') {
                        this.$swal(
                            'state Created ',
                            response.data.status,
                            'success'
                        );
                    }
                    this.form.stateName = "";                    
                    
                    this.loading = false;
                    this.btnText = "Save";
                    this.removeValidations();
                } catch (error) {
                    // console.log("this is error ", error)
                    if (error.response.status === 422) {
                        // console.log(error.response.data.errors.name);
                        this.errors = error.response.data.errors;
                        this.checkValidations();

                    }
                    this.loading = false;
                    // console.log(errors.value.name);
                }
            } else {
                // alert('update');
                try {
                    this.loading = true;
                    const response = await State.updateState(this.form, this.form.id);
                    // console.log(response);
                    if (response.data.status == 'success') {
                        this.$swal(
                            'state Updated ',
                            response.data.status,
                            'success'
                        );
                    }
                    this.form.stateName = "";                    
                    this.loading = false;
                    this.btnText = "Save";
                    this.removeValidations();

                } catch (error) {
                    // console.log("this is error ", error)
                    if (error.response.status === 422) {
                        // console.log(error.response.data.errors.name);
                        this.errors = error.response.data.errors;
                        this.checkValidations();
                    }
                    this.loading = false;
                    // console.log(errors.value.name);
                }

            }
            this.loading = true
            let response = await State.getStates();
            // console.log(response.data);
            this.states = response.data;
            this.loading = false;


        },
        async editdata(id) {
            // alert(id);
            this.loading = true;
            this.btnText = "Update";
            const response = await State.getState(id);
            this.form.id = id;
            this.form.stateName = response.data.stateName;
            this.form.countryId = response.data.countryId;
            
            // console.log(response.data.name);
            // this.btnText = "Save";
            this.seen = true;
            this.loading = false;
        },
        async deletedata(id) {
            let result = await this.$swal({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            });
            // alert(result.isConfirmed);
            if (result.isConfirmed) {
                this.loading = true;
                const resDel = await State.deleteState(id);
                // console.log(resDel);
                if (resDel.status == 204) {
                    this.$swal(
                        'state Deleted',
                        resDel.data.status,
                        'success'
                    );
                }

            }

            // alert(id);

            // this.loading = true;
            let response = await State.getStates();
            this.states = response.data;
            this.loading = false;
        },
        hideFrom() {

        }
    },
}
</script>
<style scoped>  
.state-mas {
    background: #fbfbfb;
    border: solid 1px #d2d2d2;
    padding: 30px;
    margin: 20px 0px;
}

.state-mas .form-control {
    padding: 12px 10px;
    border-radius: 0;

}

.state-mas .form-select {
    padding: 12px 10px;
    border-radius: 0;
}

.btn-bottom {
    text-align: center;
}

.state-mas .btn.btn-primary {
    border-radius: 3px;
    padding: 10px 25px;
    display: inline-block;
    font-size: 18px;
    font-weight: 700;
}

.table>thead {
    vertical-align: bottom;
    background: lightskyblue;
}

tbody tr td {
    border-right: 1px solid #a7daf9;
}

tbody tr td:first-child {
    border-left: 1px solid #a7daf9;
}


tr.odd {
    background-color: #FFF;
    vertical-align: middle;
}

tr.even {
    background-color: #e5f5ff;
    vertical-align: middle;
}
</style>